import React from "react";

import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  List,
  ListItem,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import { NewsProps } from "./types";
import NewsItem from "./NewsItem";
import NewsSkeleton from "./components/Skeleton";

const useStyles = makeStyles(theme => ({
  noItems: {
    flexGrow: 1,
    margin: theme.spacing(1.5),
    textAlign: "center",
    color: theme.palette.grey[500],
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
  },
  footerIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    color: theme.palette.secondary.main,
  },
}));

const News: React.FC<NewsProps> = ({
  loading = false,
  newsItems = [],
  handleNewsItemClick = () => {},
  handleViewAllClick = () => {},
}) => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader
        titleTypographyProps={{ component: "h3", variant: "h3" }}
        title="Updates"
      />
      <Divider />
      {loading ? (
        <NewsSkeleton />
      ) : (
        <List data-test="news-list">
          {newsItems.length ? (
            newsItems.map(newsItem => (
              <NewsItem
                key={newsItem.id}
                newsItem={newsItem}
                handleClick={handleNewsItemClick}
              />
            ))
          ) : (
            <ListItem className={classes.noItems}>
              <Typography className={classes.noItems}>
                No updates, you are all caught up.
              </Typography>
            </ListItem>
          )}
        </List>
      )}
      <Divider />
      <Box flexGrow={1} className={classes.footer}>
        <Button
          endIcon={<ChevronRight width={20} />}
          to="/messages/news"
          component={Link}
          onClick={handleViewAllClick}
          className={classes.button}
          data-test="see-all-news-link"
        >
          See all
        </Button>
      </Box>
    </Card>
  );
};

export default News;
